<header class="flex header">
  <h2>
    {{ inventoryType?.id ? ('Inventory_Types_Edit' | translateWF: 'Edit Inventory Type') : ('Inventory_Types_Add' | translateWF: 'Add Inventory Type') }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" [disabled]="isLoading" />
</header>

@if (isLoading) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}

<section class="content">
  <p-card>
    <div class="row-start-center">
      <i class="pi pi-language"></i>
      <p>{{ 'InventoryTypeModal.Switch' | translateWF: 'Spanish Translate' }}</p>
      <p-toggleswitch [(ngModel)]="showTranslateInputs" (onChange)="onTranslateChange($event)" />
    </div>

    <form [formGroup]="itemInventoryFormGroup">
      <div class="col">
        <!-- NAME FIELD - Usando la estructura anidada -->
        <div class="form-box" formGroupName="name">
          <label>{{ 'Inventory_Types_Name' | translateWF: 'Name' }}</label>

          <!-- English Name -->
          <p-inputGroup>
            <p-inputGroupAddon>EN</p-inputGroupAddon>
            <input
              pInputText
              type="text"
              class="w-full"
              formControlName="en"
              [ngClass]="{
                'ng-invalid ng-dirty': submittedForm && itemNameFormGroup.get('en')?.invalid,
              }"
            />
          </p-inputGroup>
          <!-- Spanish Name (conditionally shown) -->
          @if (showTranslateInputs) {
            <p-inputgroup>
              <p-inputgroup-addon>ES</p-inputgroup-addon>
              <input
                pInputText
                type="text"
                class="w-full"
                formControlName="es"
                [ngClass]="{
                  'ng-invalid ng-dirty': submittedForm && itemNameFormGroup.get('es')?.invalid,
                }"
              />
            </p-inputgroup>
          }

          <!-- Validation Messages -->
          @if (submittedForm && (itemNameFormGroup.get('en')?.invalid || itemNameFormGroup.get('es')?.invalid)) {
            <div class="text-red-500 text-sm mt-1">
              <div *ngIf="itemNameFormGroup.get('en')?.errors?.['required'] || itemNameFormGroup.get('es')?.errors?.['required']">
                {{ 'Common_Name_Required' | translateWF: 'Name is required.' }}
              </div>
            </div>
          }
        </div>

        <!-- DESCRIPTION FIELD - Campo plano -->
        <div class="form-box">
          <label>{{ 'Common_Description' | translateWF: 'Description' }}</label>

          <textarea
            rows="2"
            cols="30"
            pTextarea
            class="w-full"
            formControlName="description"
            [ngClass]="{
              'ng-invalid ng-dirty': submittedForm && itemInventoryFormGroup.get('description')?.invalid,
            }"
          ></textarea>

          @if (submittedForm && itemInventoryFormGroup.get('description')?.invalid) {
            <div class="text-red-500 text-sm">
              <div *ngIf="itemInventoryFormGroup.get('description')?.errors?.['required']">
                {{ 'Common_Description_Required' | translateWF: 'Description is required.' }}
              </div>
            </div>
          }
        </div>
      </div>
    </form>
  </p-card>
</section>

<footer>
  <p-button *ngIf="canEdit()" class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" [disabled]="isLoading" />
  <p-button class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" [disabled]="isLoading" />
</footer>
